import React from 'react';
import { v4 as uuid } from 'uuid';

// Interfaces
import {
    TableHead,
    CheckColumnWithId,
    CheckColumnWithoutId,
    GenericItem,
    SortHandler
} from '@components/UI-KIT/Table';
import { Action } from '@components/UI-KIT/ContextMenu';

// Material ui
import {
    TableHead as MaterialTableHead,
    TableRow,
    TableCell,
    Grid
} from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';

// Icons
import { NotSort, SortAsc, SortDesc } from '@/assets/icons';

interface Props<T extends GenericItem> {
    tableHead: TableHead[];
    checkFromTheLeft?: CheckColumnWithoutId;
    checkFromTheRight?: CheckColumnWithoutId;
    checkWithId?: CheckColumnWithId;
    actions?: Action<T>[];
    sortHandler?: SortHandler;
    handleTableHeadSortClick?: (_columnIndex: number) => void;
}

function GenericTableHead<T extends GenericItem>({
    tableHead,
    checkFromTheLeft,
    checkFromTheRight,
    checkWithId,
    actions,
    sortHandler,
    handleTableHeadSortClick
}: Props<T>) {

    const getSortIcon = (index: number, sortable: boolean) => {
        if (sortable && sortHandler) {
            const { columnIndex, direction } = sortHandler;

            if (columnIndex === index) {
                return direction === 'ASC' ? (
                    <SortAsc
                        width={12}
                        height={12}
                    />
                ) : (
                    <SortDesc
                        width={12}
                        height={12}
                    />
                );
            }
        }

        return sortable ? (
            <NotSort
                width={12}
                height={12}
            />
        ) : null;
    };

    return (
        <>
            <MaterialTableHead
                className="ui-Table-generic-head"
            >
                <TableRow
                    className="ui-Table-head-row"
                >
                    {checkFromTheLeft && (
                        <TableCell
                            className="ui-Table-cell"
                        >
                            {checkFromTheLeft.label}
                        </TableCell>
                    )}
                    {checkWithId && (
                        <TableCell
                            className="ui-Table-cell"
                        >
                            {checkWithId.label}
                        </TableCell>
                    )}
                    { tableHead.map((head, index) => (
                        <TableCell
                            key={uuid()}
                            className="ui-Table-cell"
                        >
                            <a
                                onClick={() => head.sortable && handleTableHeadSortClick && handleTableHeadSortClick(index)}
                            >
                                <Grid
                                    container
                                    alignItems="center"
                                >
                                    <Typography
                                        color="primary-dark"
                                        variant="note-semibold"
                                    >
                                        {head.label}
                                    </Typography>
                                    &nbsp;
                                    {getSortIcon(index, head.sortable)}
                                </Grid>
                            </a>
                        </TableCell>
                    ))}
                    {checkFromTheRight && (
                        <TableCell
                            className="ui-Table-cell"
                        >
                            {checkFromTheRight.label}
                        </TableCell>
                    )}
                    { actions && (
                        <TableCell
                            className="ui-Table-cell Actions"
                        >
                            Acciones
                        </TableCell>
                    )}
                </TableRow>
            </MaterialTableHead>

        </>
    );};

export default GenericTableHead;
